import React from 'react';
import Button from '../../../components/ui/Button';
import Icon from '../../../components/AppIcon';

const SocialRegistration = ({ onSocialRegister, isLoading }) => {
  const socialOptions = [
    {
      provider: 'google',
      name: 'Google',
      icon: 'Chrome',
      bgColor: 'bg-white/5 hover:bg-white/10',
      textColor: 'text-foreground',
      borderColor: 'border-white/10'
    },
    {
      provider: 'discord',
      name: 'Discord',
      icon: 'MessageCircle',
      bgColor: 'bg-[#5865F2]/10 hover:bg-[#5865F2]/20',
      textColor: 'text-foreground',
      borderColor: 'border-[#5865F2]/20'
    },
    {
      provider: 'twitch',
      name: 'Twitch',
      icon: 'Twitch',
      bgColor: 'bg-[#9146FF]/10 hover:bg-[#9146FF]/20',
      textColor: 'text-foreground',
      borderColor: 'border-[#9146FF]/20'
    }
  ];

  return (
    <div className="space-y-3">
      <div className="text-center">
        <p className="text-sm text-muted-foreground mb-4">Quick registration with</p>
      </div>
      
      <div className="grid grid-cols-1 sm:grid-cols-2 gap-3">
        {socialOptions.map((option) => (
          <Button
            key={option.provider}
            variant="outline"
            size="default"
            onClick={() => onSocialRegister(option.provider)}
            disabled={isLoading}
            className={`${option.bgColor} ${option.textColor} ${option.borderColor} border-2 transition-all duration-200 hover:scale-105`}
          >
            <Icon name={option.icon} size={20} className="mr-2" />
            {option.name}
          </Button>
        ))}
      </div>
      
      <div className="relative my-6">
        <div className="absolute inset-0 flex items-center">
          <div className="w-full border-t border-border"></div>
        </div>
        <div className="relative flex justify-center text-sm">
          <span className="px-4 bg-background text-muted-foreground">or continue with email</span>
        </div>
      </div>
    </div>
  );
};

export default SocialRegistration;
